import { isObject } from 'lodash';

/**
 * Get Color Scheme from variant
 *
 * @param {string} selectedColor - props.colorScheme
 * @param {string} selectedVariant - props.variant
 * @param {object} colorScheme - component's color scheme see OButton.vue
 * @returns {string}
 */
export const getColorScheme = (selectedColor, selectedVariant, colorScheme) => {
  const currentScheme = colorScheme?.[selectedColor];

  // colorSchemes.gray: { default: '', solid: '' }
  if (isObject(currentScheme)) {
    if (selectedVariant in currentScheme) {
      return currentScheme?.[selectedVariant]; // 'colorSchemes.gray.outline'
    }
    return currentScheme?.default; // 'colorSchemes.gray.default'
  }

  // colorSchemes.gray: ''
  return currentScheme || '';
};
